import type { BrowserOptions } from '@sentry/angular';

/**
 * Severity of an ErrorService log. Level is only an attribute of the log: it creates no Sentry
 * event and fires no alert.
 */
export type ErrorLogLevel = 'info' | 'warn' | 'error';

/** The attribute value types Sentry Logs stores natively; anything else is serialised first. */
export type StructuredLogAttributes = Record<string, string | number | boolean>;

/** A log payload mapped onto Sentry Logs' message + attributes. */
export interface StructuredLog {
	message: string;
	attributes: StructuredLogAttributes;
}

/** The subset of a log payload ErrorService reads; every other key becomes an attribute. */
export interface ErrorLogPayload {
	text?: unknown;
	[key: string]: unknown;
}

/** Any non-null object. A payload's keys are read defensively: the declared shape is not trusted. */
export function isErrorLogPayload(value: unknown): value is ErrorLogPayload {
	return typeof value === 'object' && value !== null;
}

/** A log as Sentry hands it to `beforeSendLog`. */
export type SentryLog = Parameters<NonNullable<BrowserOptions['beforeSendLog']>>[0];
